import { c as _c } from "react/compiler-runtime";
import { twMerge } from 'tailwind-merge';
type Props = {
  label?: string;
} & React.ComponentPropsWithoutRef<'div'>;
export function Divider(t0) {
  const $ = _c(13);
  let className;
  let label;
  let rest;
  if ($[0] !== t0) {
    ({
      className,
      label,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = label;
    $[3] = rest;
  } else {
    className = $[1];
    label = $[2];
    rest = $[3];
  }
  let t1;
  if ($[4] !== className) {
    t1 = twMerge("relative", className);
    $[4] = className;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="absolute inset-0 flex items-center"><div className="w-full border-t" /></div>;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== label) {
    t3 = label && <div className="relative flex justify-center"><span className="rounded-full bg-white px-4 font-mono font-light text-zinc-500 dark:bg-zinc-900">{label}</span></div>;
    $[7] = label;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== rest || $[10] !== t1 || $[11] !== t3) {
    t4 = <div className={t1} aria-hidden="true" {...rest}>{t2}{t3}</div>;
    $[9] = rest;
    $[10] = t1;
    $[11] = t3;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  return t4;
}